import axios from 'axios';

import {
  hubspotUrl
} from "../../constants/defaultValues"

const axiosHubspot = axios.create()
axiosHubspot.interceptors.request.use((config) => {
  config.baseURL = hubspotUrl
  config.headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "authorizationToken": `Bearer ${process.env.REACT_APP_HUBSPOT_TOKEN}`
  }
  return config
}, (error) => {
  return Promise.reject(error);
})
axiosHubspot.interceptors.response.use((response) => {
  return response;
}, (error) => {
  return Promise.reject(error);
});

export default axiosHubspot;